import { Injectable } from '@angular/core';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class MyHammerConfig extends HammerGestureConfig {
  override overrides: any = {
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}
